// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./spinner.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step0-header.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step1-browseFile.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step1_InputFormatPopup.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step2-uploadFile.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step3-getColumn.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step3_ColumnSearchModal.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step4-selectClass.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step5-selectAnalysis.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step6-selectFeature.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step6_modal.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step7-runAnalysis.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step8_0-showGraph.css";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step8_1-zoomGraph.css";
import ___CSS_LOADER_AT_RULE_IMPORT_14___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step8_2-showParameters.css";
import ___CSS_LOADER_AT_RULE_IMPORT_15___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step8_3-showStatistics.css";
import ___CSS_LOADER_AT_RULE_IMPORT_16___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./step9-generateAnalysisReport.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_14___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_15___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: Arial, sans-serif;
}

/* Global Dropdown Styles */
select, option {
  font-size: 16px;
}

.combine-aggregation-controls select {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: white;
  font-size: 16px;
}

/* Categorical Encoding Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-body p {
  margin-bottom: 15px;
  color: #555;
}

.encoding-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
  border-left: 4px solid #007bff;
}

.encoding-info h4 {
  margin: 0 0 10px 0;
  color: #333;
}

.encoding-info p {
  margin: 5px 0;
}

.encoding-info ul {
  margin: 10px 0;
  padding-left: 20px;
}

.encoding-info li {
  margin: 5px 0;
  color: #666;
}

.encoding-note {
  margin-top: 20px;
  padding: 15px;
  background-color: #e9f7ef;
  border-radius: 5px;
  border-left: 4px solid #28a745;
}

.encoding-note p {
  margin: 0;
  color: #155724;
  font-size: 14px;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #e9ecef;
  text-align: right;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

/* === Step 5: Aesthetic Enhancements for Analysis Selection === */

.analysis-tables {
  display: flex;
  flex-direction: column;
  gap: 20px; /* Space between rows */
  max-width: 1240px;
  width: 100%;
  margin: 0 auto; /* Center the container itself to keep a consistent left edge */
}

.analysis-row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px; /* Space between category cards */
  width: fit-content;
  margin: 0 auto;
}

.two-card-row {
  width: fit-content;
}

.three-card-row {
  width: fit-content;
}

.analysis-category {
  flex: 0 0 300px;
  width: 300px;
  min-width: 300px;
  max-width: 300px;
  background: #fdfdfd;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 15px;
  transition: box-shadow 0.3s ease;
}

.analysis-category:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.analysis-category h4 {
  display: flex;
  align-items: center;
  gap: 8px; /* Space between icon and text */
  font-size: 16px;
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  color: #333;
}

.analysis-category table {
  width: 100%;
  border-collapse: collapse;
}

.analysis-category tr {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.analysis-category tr:hover {
  background-color: #f5f5f5;
}

.analysis-category tr.selected {
  background-color: #e3f2fd !important; /* Use important to override hover */
  font-weight: 500;
  color: #0d47a1;
}

/* Disabled (incompatible) method rows */
.analysis-category tr.disabled-method {
  cursor: not-allowed;
  background-color: #fafafa;
}
.analysis-category tr.disabled-method:hover {
  background-color: #fafafa;
}

.analysis-category td {
  padding: 10px 8px;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.analysis-category tr:last-child td {
  border-bottom: none;
}

/* Container for Classification and its related Explanation */
.classification-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  width: fit-content;
  max-width: none;
  margin: 0;
}

/* Styling for the arrow connector */
.connector {
  opacity: 0;
  transform: scale(0.8);
  transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
  color: #007bff;
}

.connector.visible {
  opacity: 1;
  transform: scale(1);
}

/* Styling for the Model Explanation category card */
.model-explanation-category {
  opacity: 0;
  pointer-events: none; /* Prevents interaction when hidden */
  transition: opacity 0.4s ease-in-out;
}

.model-explanation-category.visible {
  opacity: 1;
  pointer-events: auto; /* Allows interaction when visible */
}

.optional-text {
  font-size: 12px;
  font-weight: 400;
  color: #757575;
  margin-left: 8px;
}

/* New wrapper for tables and confirm button */
.analysis-content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;           /* center the grid within page */
  align-items: center;
  gap: 30px;                  /* space between tables and button */
  width: 100%;
}

.analysis-tables {
  width: 100%;
}

.analysis-button {
  margin: 0 auto;
}

/* Post-analysis action layout (single + multiple analysis flows) */
.post-analysis-options {
  width: min(1120px, 100%);
  margin: 16px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.post-analysis-options .button {
  width: min(620px, 100%);
  margin: 0;
}

.post-analysis-options .or-container {
  margin: 4px 0;
}

.post-analysis-options .or-text {
  margin: 0;
  line-height: 1;
  letter-spacing: 0.04em;
}

.post-analysis-options .feature-count-selector {
  width: min(860px, 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;
  padding: 4px 0;
}

.post-analysis-options .feature-count-selector label {
  margin-right: 0;
}

.post-analysis-options .combine-aggregation-controls {
  width: min(900px, 100%);
  padding: 0;
}

.post-analysis-options .kegg-trigger-container,
.post-analysis-options .validation-panel,
.post-analysis-options .kegg-analysis-results {
  width: min(1120px, 100%);
  margin-top: 2px;
}

.post-analysis-options .validation-action-bar {
  width: min(520px, 100%);
  margin: 0;
  gap: 8px;
}

.post-analysis-options .validation-or-separator {
  margin: 0;
  font-size: 24px;
}

.post-analysis-options .generate-report-button {
  margin-top: 12px;
}

@media (max-width: 768px) {
  .post-analysis-options {
    width: 100%;
    gap: 10px;
  }

  .post-analysis-options .button,
  .post-analysis-options .kegg-trigger-button {
    width: 100%;
    min-width: 0;
  }

  .post-analysis-options .feature-count-selector {
    justify-content: flex-start;
  }

  .post-analysis-options .feature-count-selector label {
    width: 100%;
  }
}

/* KEGG pathway analysis results */
.kegg-trigger-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.enrichment-button-grid {
  margin-bottom: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  width: 100%;
  max-width: 980px;
}

.kegg-trigger-button {
  margin: 0;
  min-width: 260px;
  padding: 12px 18px;
  border: 1px solid #b5c7eb;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5f8ff 0%, #6391fc 100%);
  color: #1f2a44;
  font-weight: 600;
  letter-spacing: 0.3px;
  box-shadow: 0 4px 12px rgba(31, 42, 68, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.kegg-trigger-button:hover {
  box-shadow: 0 6px 16px rgba(31, 42, 68, 0.18);
  background: linear-gradient(135deg, #e9f1ff 0%, #c9d9ff 100%);
}

.kegg-trigger-button:focus-visible {
  outline: 3px solid rgba(75, 109, 167, 0.35);
  outline-offset: 3px;
}

.kegg-trigger-button:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
  border-color: #cdd3e5;
  box-shadow: none;
  transform: none;
}

.kegg-trigger-button:disabled:hover {
  background-color: #e3e6ef;
}

.kegg-analysis-results {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.kegg-analysis-card {
  width: 100%;
  align-self: stretch;
  border: 1px solid #d7e2ff;
  border-radius: 8px;
  padding: 16px;
  background: #f4f7ff;
}

.kegg-analysis-title {
  margin: 0 0 8px 0;
}

.kegg-summary-text {
  margin: 0 0 12px 0;
  color: #2b365a;
}

.kegg-stats-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 14px;
  color: #2b365a;
}

.kegg-download {
  margin-top: 12px;
}

.kegg-download-link {
  font-weight: 600;
  text-decoration: underline;
  color: #2f4fb5;
}

.kegg-download-link:hover {
  color: #1d357d;
}

.kegg-table-wrapper {
  margin-top: 16px;
  overflow-x: auto;
}

.kegg-table {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  background: #ffffff;
}

.kegg-table-header {
  border: 1px solid #d7e2ff;
  background: #eaf0ff;
  padding: 8px 10px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: #2b365a;
}

.kegg-table-cell {
  border: 1px solid #d7e2ff;
  padding: 6px 10px;
  font-size: 13px;
  color: #2b365a;
  word-break: break-word;
  white-space: normal;
}

.kegg-table-footnote {
  margin-top: 8px;
  font-size: 12px;
  color: #4b5975;
}

.kegg-table-header--index,
.kegg-table-cell--index {
  text-align: center;
  width: 60px;
  min-width: 60px;
}

/* Analysis Queue Notification */
.analysis-notification {
  position: fixed;
  top: 100px;
  right: 20px;
  z-index: 9999;
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.analysis-notification-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 20px;
  min-width: 350px;
  max-width: 400px;
  display: flex;
  align-items: flex-start;
  gap: 15px;
  border-left: 4px solid #4CAF50;
}

.notification-icon {
  font-size: 32px;
  flex-shrink: 0;
}

.notification-text {
  flex: 1 1;
}

.notification-text strong {
  display: block;
  font-size: 16px;
  margin-bottom: 5px;
  color: #2b365a;
}

.notification-text p {
  margin: 5px 0;
  font-size: 14px;
  color: #4b5975;
}

.queue-position {
  font-style: italic;
  color: #7289da;
}

.notification-button {
  background: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background 0.2s;
  margin-top: 10px;
}

.notification-button:hover {
  background: #45a049;
}

.notification-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.notification-close:hover {
  color: #333;
}

.analysis-notification-content .spinner {
  width: 24px;
  height: 24px;
  border-width: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAoBA,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kEAAkE;;AAElE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,uBAAuB;EAClC,iBAAiB;EACjB,WAAW;EACX,cAAc,EAAE,+DAA+D;AACjF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS,EAAE,iCAAiC;EAC5C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,gCAAgC;EAC1C,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC,EAAE,oCAAoC;EAC1E,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,UAAU;EACV,qBAAqB;EACrB,gEAAgE;EAChE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,UAAU;EACV,oBAAoB,EAAE,qCAAqC;EAC3D,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,oBAAoB,EAAE,oCAAoC;AAC5D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,YAAY,gCAAgC;EACnE,mBAAmB;EACnB,SAAS,mBAAmB,oCAAoC;EAChE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;;EAGE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;EAC7C,2EAA2E;AAC7E;;AAEA;EACE,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":["body {\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n/* Global Dropdown Styles */\nselect, option {\n  font-size: 16px;\n}\n\n.combine-aggregation-controls select {\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  background-color: white;\n  font-size: 16px;\n}\n\n@import './spinner.css';\n@import './step0-header.css';\n@import './step1-browseFile.css';\n@import './step1_InputFormatPopup.css';\n@import './step2-uploadFile.css';\n@import './step3-getColumn.css';\n@import './step3_ColumnSearchModal.css';\n@import './step4-selectClass.css';\n@import './step5-selectAnalysis.css';\n@import './step6-selectFeature.css';\n@import './step6_modal.css';\n@import './step7-runAnalysis.css';\n@import './step8_0-showGraph.css';\n@import './step8_1-zoomGraph.css';\n@import './step8_2-showParameters.css';\n@import './step8_3-showStatistics.css';\n@import './step9-generateAnalysisReport.css';\n\n/* Categorical Encoding Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-button:hover {\n  color: #333;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-body p {\n  margin-bottom: 15px;\n  color: #555;\n}\n\n.encoding-info {\n  margin-bottom: 20px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 5px;\n  border-left: 4px solid #007bff;\n}\n\n.encoding-info h4 {\n  margin: 0 0 10px 0;\n  color: #333;\n}\n\n.encoding-info p {\n  margin: 5px 0;\n}\n\n.encoding-info ul {\n  margin: 10px 0;\n  padding-left: 20px;\n}\n\n.encoding-info li {\n  margin: 5px 0;\n  color: #666;\n}\n\n.encoding-note {\n  margin-top: 20px;\n  padding: 15px;\n  background-color: #e9f7ef;\n  border-radius: 5px;\n  border-left: 4px solid #28a745;\n}\n\n.encoding-note p {\n  margin: 0;\n  color: #155724;\n  font-size: 14px;\n}\n\n.modal-footer {\n  padding: 20px;\n  border-top: 1px solid #e9ecef;\n  text-align: right;\n}\n\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.btn-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #0056b3;\n}\n\n/* === Step 5: Aesthetic Enhancements for Analysis Selection === */\n\n.analysis-tables {\n  display: flex;\n  flex-direction: column;\n  gap: 20px; /* Space between rows */\n  max-width: 1240px;\n  width: 100%;\n  margin: 0 auto; /* Center the container itself to keep a consistent left edge */\n}\n\n.analysis-row {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 20px; /* Space between category cards */\n  width: fit-content;\n  margin: 0 auto;\n}\n\n.two-card-row {\n  width: fit-content;\n}\n\n.three-card-row {\n  width: fit-content;\n}\n\n.analysis-category {\n  flex: 0 0 300px;\n  width: 300px;\n  min-width: 300px;\n  max-width: 300px;\n  background: #fdfdfd;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  padding: 15px;\n  transition: box-shadow 0.3s ease;\n}\n\n.analysis-category:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.analysis-category h4 {\n  display: flex;\n  align-items: center;\n  gap: 8px; /* Space between icon and text */\n  font-size: 16px;\n  margin-top: 0;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n  color: #333;\n}\n\n.analysis-category table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.analysis-category tr {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.analysis-category tr:hover {\n  background-color: #f5f5f5;\n}\n\n.analysis-category tr.selected {\n  background-color: #e3f2fd !important; /* Use important to override hover */\n  font-weight: 500;\n  color: #0d47a1;\n}\n\n/* Disabled (incompatible) method rows */\n.analysis-category tr.disabled-method {\n  cursor: not-allowed;\n  background-color: #fafafa;\n}\n.analysis-category tr.disabled-method:hover {\n  background-color: #fafafa;\n}\n\n.analysis-category td {\n  padding: 10px 8px;\n  font-size: 14px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.analysis-category tr:last-child td {\n  border-bottom: none;\n}\n\n/* Container for Classification and its related Explanation */\n.classification-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 20px;\n  width: fit-content;\n  max-width: none;\n  margin: 0;\n}\n\n/* Styling for the arrow connector */\n.connector {\n  opacity: 0;\n  transform: scale(0.8);\n  transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;\n  color: #007bff;\n}\n\n.connector.visible {\n  opacity: 1;\n  transform: scale(1);\n}\n\n/* Styling for the Model Explanation category card */\n.model-explanation-category {\n  opacity: 0;\n  pointer-events: none; /* Prevents interaction when hidden */\n  transition: opacity 0.4s ease-in-out;\n}\n\n.model-explanation-category.visible {\n  opacity: 1;\n  pointer-events: auto; /* Allows interaction when visible */\n}\n\n.optional-text {\n  font-size: 12px;\n  font-weight: 400;\n  color: #757575;\n  margin-left: 8px;\n}\n\n/* New wrapper for tables and confirm button */\n.analysis-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;           /* center the grid within page */\n  align-items: center;\n  gap: 30px;                  /* space between tables and button */\n  width: 100%;\n}\n\n.analysis-tables {\n  width: 100%;\n}\n\n.analysis-button {\n  margin: 0 auto;\n}\n\n/* Post-analysis action layout (single + multiple analysis flows) */\n.post-analysis-options {\n  width: min(1120px, 100%);\n  margin: 16px auto 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.post-analysis-options .button {\n  width: min(620px, 100%);\n  margin: 0;\n}\n\n.post-analysis-options .or-container {\n  margin: 4px 0;\n}\n\n.post-analysis-options .or-text {\n  margin: 0;\n  line-height: 1;\n  letter-spacing: 0.04em;\n}\n\n.post-analysis-options .feature-count-selector {\n  width: min(860px, 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 0;\n  padding: 4px 0;\n}\n\n.post-analysis-options .feature-count-selector label {\n  margin-right: 0;\n}\n\n.post-analysis-options .combine-aggregation-controls {\n  width: min(900px, 100%);\n  padding: 0;\n}\n\n.post-analysis-options .kegg-trigger-container,\n.post-analysis-options .validation-panel,\n.post-analysis-options .kegg-analysis-results {\n  width: min(1120px, 100%);\n  margin-top: 2px;\n}\n\n.post-analysis-options .validation-action-bar {\n  width: min(520px, 100%);\n  margin: 0;\n  gap: 8px;\n}\n\n.post-analysis-options .validation-or-separator {\n  margin: 0;\n  font-size: 24px;\n}\n\n.post-analysis-options .generate-report-button {\n  margin-top: 12px;\n}\n\n@media (max-width: 768px) {\n  .post-analysis-options {\n    width: 100%;\n    gap: 10px;\n  }\n\n  .post-analysis-options .button,\n  .post-analysis-options .kegg-trigger-button {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .post-analysis-options .feature-count-selector {\n    justify-content: flex-start;\n  }\n\n  .post-analysis-options .feature-count-selector label {\n    width: 100%;\n  }\n}\n\n/* KEGG pathway analysis results */\n.kegg-trigger-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.enrichment-button-grid {\n  margin-bottom: 25px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  max-width: 980px;\n}\n\n.kegg-trigger-button {\n  margin: 0;\n  min-width: 260px;\n  padding: 12px 18px;\n  border: 1px solid #b5c7eb;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #f5f8ff 0%, #6391fc 100%);\n  color: #1f2a44;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  box-shadow: 0 4px 12px rgba(31, 42, 68, 0.12);\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.kegg-trigger-button:hover {\n  box-shadow: 0 6px 16px rgba(31, 42, 68, 0.18);\n  background: linear-gradient(135deg, #e9f1ff 0%, #c9d9ff 100%);\n}\n\n.kegg-trigger-button:focus-visible {\n  outline: 3px solid rgba(75, 109, 167, 0.35);\n  outline-offset: 3px;\n}\n\n.kegg-trigger-button:disabled {\n  background-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n  border-color: #cdd3e5;\n  box-shadow: none;\n  transform: none;\n}\n\n.kegg-trigger-button:disabled:hover {\n  background-color: #e3e6ef;\n}\n\n.kegg-analysis-results {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.kegg-analysis-card {\n  width: 100%;\n  align-self: stretch;\n  border: 1px solid #d7e2ff;\n  border-radius: 8px;\n  padding: 16px;\n  background: #f4f7ff;\n}\n\n.kegg-analysis-title {\n  margin: 0 0 8px 0;\n}\n\n.kegg-summary-text {\n  margin: 0 0 12px 0;\n  color: #2b365a;\n}\n\n.kegg-stats-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  font-size: 14px;\n  color: #2b365a;\n}\n\n.kegg-download {\n  margin-top: 12px;\n}\n\n.kegg-download-link {\n  font-weight: 600;\n  text-decoration: underline;\n  color: #2f4fb5;\n}\n\n.kegg-download-link:hover {\n  color: #1d357d;\n}\n\n.kegg-table-wrapper {\n  margin-top: 16px;\n  overflow-x: auto;\n}\n\n.kegg-table {\n  width: 100%;\n  min-width: 900px;\n  border-collapse: collapse;\n  background: #ffffff;\n}\n\n.kegg-table-header {\n  border: 1px solid #d7e2ff;\n  background: #eaf0ff;\n  padding: 8px 10px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 14px;\n  color: #2b365a;\n}\n\n.kegg-table-cell {\n  border: 1px solid #d7e2ff;\n  padding: 6px 10px;\n  font-size: 13px;\n  color: #2b365a;\n  word-break: break-word;\n  white-space: normal;\n}\n\n.kegg-table-footnote {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #4b5975;\n}\n\n.kegg-table-header--index,\n.kegg-table-cell--index {\n  text-align: center;\n  width: 60px;\n  min-width: 60px;\n}\n\n/* Analysis Queue Notification */\n.analysis-notification {\n  position: fixed;\n  top: 100px;\n  right: 20px;\n  z-index: 9999;\n  animation: slideInRight 0.3s ease-out;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(400px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.analysis-notification-content {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 20px;\n  min-width: 350px;\n  max-width: 400px;\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n  border-left: 4px solid #4CAF50;\n}\n\n.notification-icon {\n  font-size: 32px;\n  flex-shrink: 0;\n}\n\n.notification-text {\n  flex: 1;\n}\n\n.notification-text strong {\n  display: block;\n  font-size: 16px;\n  margin-bottom: 5px;\n  color: #2b365a;\n}\n\n.notification-text p {\n  margin: 5px 0;\n  font-size: 14px;\n  color: #4b5975;\n}\n\n.queue-position {\n  font-style: italic;\n  color: #7289da;\n}\n\n.notification-button {\n  background: #4CAF50;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background 0.2s;\n  margin-top: 10px;\n}\n\n.notification-button:hover {\n  background: #45a049;\n}\n\n.notification-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: #999;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.notification-close:hover {\n  color: #333;\n}\n\n.analysis-notification-content .spinner {\n  width: 24px;\n  height: 24px;\n  border-width: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
